import React from "react"
import { Route, Routes } from "react-router-dom"
import { Offers, AddOffer } from "@/constants/lazyLoad/lazyOffers"

function OffersRoutes() {
  return (
    <Routes>
      <Route index element={<Offers />} />
      <Route path="ajout-offres" element={<AddOffer />} />
    </Routes>
  )
}

export default OffersRoutes